import React, { useEffect, useRef, useState } from 'react';

export default function CustomCursor() {
  const dotRef = useRef(null);
  const ringRef = useRef(null);
  const [variant, setVariant] = useState('default');
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    if (window.innerWidth < 1024) return;
    let mx = 0, my = 0, rx = 0, ry = 0;
    let raf;

    const move = (e) => {
      mx = e.clientX; my = e.clientY;
      if (dotRef.current) {
        dotRef.current.style.transform = `translate3d(${mx}px, ${my}px, 0) translate(-50%, -50%)`;
      }
    };

    const loop = () => {
      rx += (mx - rx) * 0.18;
      ry += (my - ry) * 0.18;
      if (ringRef.current) {
        ringRef.current.style.transform = `translate3d(${rx}px, ${ry}px, 0) translate(-50%, -50%)`;
      }
      raf = requestAnimationFrame(loop);
    };

    const onLeave = () => setHidden(true);
    const onEnter = () => setHidden(false);

    const checkHover = (e) => {
      const t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('a, button, [role="button"], .cursor-hover')) setVariant('hover');
      else if (t.closest('input, textarea, [contenteditable]')) setVariant('text');
      else setVariant('default');
    };

    window.addEventListener('mousemove', move);
    window.addEventListener('mousemove', checkHover);
    document.documentElement.addEventListener('mouseleave', onLeave);
    document.documentElement.addEventListener('mouseenter', onEnter);
    raf = requestAnimationFrame(loop);

    return () => {
      window.removeEventListener('mousemove', move);
      window.removeEventListener('mousemove', checkHover);
      document.documentElement.removeEventListener('mouseleave', onLeave);
      document.documentElement.removeEventListener('mouseenter', onEnter);
      cancelAnimationFrame(raf);
    };
  }, []);

  if (typeof window !== 'undefined' && window.innerWidth < 1024) return null;

  return (
    <>
      <div
        ref={dotRef}
        className="cursor-dot"
        style={{ opacity: hidden ? 0 : 1 }}
      />
      <div
        ref={ringRef}
        className={`cursor-ring ${variant === 'hover' ? 'hover' : ''} ${variant === 'text' ? 'text' : ''}`}
        style={{ opacity: hidden ? 0 : 1 }}
      />
    </>
  );
}
